import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./App.css";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { ApiProvider } from "./api/ApiProvider";
import { ThemeProvider } from "./shared/contexts/ThemeContext";
import { PWAInstallProvider } from "./shared/contexts/PWAInstallContext";
import App from "./App";
import "./i18n/i18n";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <ApiProvider>
      <ThemeProvider>
        <PWAInstallProvider>
          <App />
        </PWAInstallProvider>
      </ThemeProvider>
    </ApiProvider>
  </Provider>,
);

// The service worker's cache-first strategy was serving stale JS/HTML
// indefinitely after deploys (new build shipped, but browsers kept running
// the previous bundle until every tab was fully closed and reopened - never
// happens in practice, especially on mobile). This app doesn't need offline
// support, so instead of tuning the caching strategy further, remove it
// outright: never register a new one, and actively unregister + clear the
// cache for any client that already has one from a previous deploy so this
// self-heals without asking users to manually clear site data.
serviceWorkerRegistration.unregister();
if ("caches" in window) {
  caches.keys().then((names) => names.forEach((name) => caches.delete(name)));
}
